module.exports = __webpack_public_path__ + "static/media/吴斐然.62259d16.png";